import { questionBank as dotnetQuestions } from './dotnetQuestions';
import { angularQuestions } from './angularQuestions';
import { sqlQuestions } from './sqlQuestions';
import { pmpQuestions } from './pmpQuestions';

export const courses = [
    {
        id: 'dotnet',
        title: '.NET Interview',
        icon: 'Code',
        description: 'Master C#, ASP.NET Core, EF Core, and specialized topics.',
        questions: dotnetQuestions,
        color: 'from-blue-600 to-purple-600',
        accent: 'text-blue-600',
        bg: 'bg-blue-50'
    },
    {
        id: 'angular',
        title: 'Angular Interview',
        icon: 'Layout',
        description: 'Prepare for Angular Core, RxJS, Services, and modern features.',
        questions: angularQuestions,
        color: 'from-red-600 to-pink-600',
        accent: 'text-red-600',
        bg: 'bg-red-50'
    },
    {
        id: 'sql',
        title: 'SQL Master',
        icon: 'Database',
        description: 'Ace your Database Design, Normalization, T-SQL, and Performance queries.',
        questions: sqlQuestions,
        color: 'from-orange-500 to-amber-500',
        accent: 'text-orange-600',
        bg: 'bg-orange-50'
    },
    {
        id: 'pmp',
        title: 'PMP Exam Prep',
        icon: 'Award',
        description: 'PMBOK Guide, Agile, Process Groups, and Knowledge Areas.',
        questions: pmpQuestions,
        color: 'from-emerald-600 to-teal-600',
        accent: 'text-emerald-600',
        bg: 'bg-emerald-50'
    }
];
